module.exports = __webpack_public_path__ + "static/media/kitchenBubbles@2x.cc0622ff.png";